export default __webpack_public_path__ + "static/productInfoManagementVp1-b889daf230e43a4d1587673566921f5b.png";